import script from "./SucursalForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SucursalForm.vue?vue&type=script&setup=true&lang=js"

import "./SucursalForm.vue?vue&type=style&index=0&id=745ab0fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-745ab0fa"]])

export default __exports__